import React, { useState } from 'react';
import {
    Alert,
    Box,
    Chip,
    Collapse,
    IconButton,
    Stack,
    Tooltip,
    Typography,
} from "@mui/material";
import { KeyboardArrowDownRounded, CategoryRounded } from "@mui/icons-material";
import { CreditUsageCategoryList } from "../../../helper/enums/CreditUsageCategoryEnum";

const _CreditCategoriesSelector = ({ usageCategories, handleCategoryToggle }) => {
    const [open, setOpen] = useState(false);

    return (
        <Box
            sx={{
                borderRadius: 3,
                border: '1px solid',
                borderColor: open ? 'primary.main' : 'divider',
                bgcolor: 'action.hover',
                overflow: 'hidden',
                transition: 'all 0.25s ease',
            }}
        >
            {/* Clickable Header Bar */}
            <Box
                onClick={() => setOpen(!open)}
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    p: 2,
                    cursor: 'pointer',
                    userSelect: 'none',
                    '&:hover': {
                        bgcolor: 'action.selected',
                    },
                    transition: 'background-color 0.2s',
                }}
            >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                    <CategoryRounded color="primary" sx={{ fontSize: 20 }} />
                    <Typography variant="subtitle2" sx={{ fontWeight: 800 }}>
                        دسته‌بندی‌های مجاز مصرف:
                    </Typography>
                    <Chip
                        size="small"
                        label={usageCategories.includes("SPORT") ? "ورزش (پیش‌فرض)" : "انتخاب نشده"}
                        color={usageCategories.length > 0 ? "primary" : "default"}
                        variant="outlined"
                        sx={{ fontWeight: 700, height: 24, fontSize: '0.75rem' }}
                    />
                </Box>

                <IconButton
                    size="small"
                    sx={{
                        transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
                        transition: 'transform 0.28s cubic-bezier(0.4, 0, 0.2, 1)',
                        color: open ? 'primary.main' : 'text.secondary',
                    }}
                >
                    <KeyboardArrowDownRounded />
                </IconButton>
            </Box>

            {/* Collapsible Content */}
            <Collapse in={open} timeout="auto" unmountOnExit={false}>
                <Box
                    sx={{
                        px: 2.5,
                        pb: 2.5,
                        pt: 1,
                        borderTop: '1px dashed',
                        borderColor: 'divider',
                    }}
                >
                    <Stack direction="row" spacing={1.2} flexWrap="wrap" useFlexGap sx={{ mb: 1.5 }}>
                        {CreditUsageCategoryList.map((cat) => {
                            const isSelected = usageCategories.includes(cat.code);
                            const isDisabled = !cat.active;

                            return (
                                <Tooltip
                                    key={cat.code}
                                    title={isDisabled ? (cat.badge || "به‌زودی — در حال حاضر غیرفعال") : (cat.description || cat.label)}
                                    arrow
                                >
                                    <span>
                                        <Chip
                                            label={cat.label + (isDisabled ? " (به‌زودی)" : "")}
                                            clickable={!isDisabled}
                                            disabled={isDisabled}
                                            onClick={!isDisabled ? () => handleCategoryToggle(cat.code) : undefined}
                                            color={isSelected ? "primary" : "default"}
                                            variant={isSelected ? "filled" : "outlined"}
                                            sx={{
                                                fontWeight: 700,
                                                py: 2,
                                                px: 1,
                                                borderRadius: 2.5,
                                                borderWidth: isSelected ? 1.5 : 1,
                                                opacity: isDisabled ? 0.45 : 1,
                                                cursor: isDisabled ? 'not-allowed !important' : 'pointer',
                                            }}
                                        />
                                    </span>
                                </Tooltip>
                            );
                        })}
                    </Stack>

                    {/* Note about active/disabled categories */}
                    <Alert severity="info" sx={{ mt: 1, py: 0.3, borderRadius: 2.5 }}>
                        <Typography variant="caption" sx={{ lineHeight: 1.5, fontWeight: 600 }}>
                            💡 در حال حاضر فقط اعتبار «ورزش» فعال است؛ سایر حوزه‌ها به‌زودی اضافه خواهند شد.
                        </Typography>
                    </Alert>
                </Box>
            </Collapse>
        </Box>
    );
};

export default _CreditCategoriesSelector;
